/**
 * layout — UI 환경설정 (사이드바 접힘 등) 저장
 * localStorage 와 동기화하여 새로고침/재접속 후에도 상태 유지
 */
const LS_KEY = 'pineapple.sidebarCollapsed';

const state = {
  sidebarCollapsed: localStorage.getItem(LS_KEY) === 'true',
};

const getters = {
  isSidebarCollapsed: (s) => s.sidebarCollapsed,
};

const mutations = {
  SET_SIDEBAR_COLLAPSED(state, v) {
    state.sidebarCollapsed = !!v;
    localStorage.setItem(LS_KEY, String(!!v));
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed;
    localStorage.setItem(LS_KEY, String(state.sidebarCollapsed));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
